import React, { useState, useEffect } from "react";
import styles from "../../style";
import { SearchBar } from "../../components";
import { FILTER_ALL_DATA } from "../../utils";
import { getToken, search } from "../../services";
import { useMsal } from "../../msalWrapper";

function Table({ item, index }) {
  const classes = "p-4 border-b border-blue-gray-50";
  return (
    <>
      <tr key={index + 1} className="font-sarabun border-t">
        <td className={classes}>{item?.tracknum}</td>
        <td className={classes}>{item?.receiverFullname}</td>
        <td className={classes}>{item?.receiverZip}</td>
        <td className={classes}>{item?.kind}</td>
        <td className={classes}>{item?.type}</td>
        <td className={classes}>{item?.GL}</td>
        <td className={classes}>{item?.order}</td>
        <td className={classes}>{item?.costcenter}</td>
        <td className={classes}>{item?.senderEid}</td>
        <td className={classes}>{item?.senderFullname}</td>
        <td className={classes}>{item?.senderDepartment}</td>
        <td className={classes}>
          {item?.dateCurrent.split("T")[0]} {item?.dateCurrent.split("T")[1]}
        </td>
        <td className={classes}>{item?.weight}</td>
        <td className={classes}>{item?.fee}</td>
        <td className={classes}>{item?.status}</td>
      </tr>
    </>
  );
}

const TABLE_HEAD = [
  "หมายเลขติดตามพัสดุ",
  "ชื่อผู้รับ",
  "รหัสไปรษณีย์",
  "ประเภทการส่ง",
  "ประเภทพัสดุ",
  "GL",
  "ORDER",
  "Costcenter",
  "รหัสพนักงาน",
  "ชื่อผู้ส่ง",
  "ส่วน",
  "วันที่",
  "น้ำหนัก",
  "ค่าส่ง",
  "สถานะ",
];

const SendParcelsOut = () => {
  const [parcelData, setParcelData] = useState([]);
  const { instance } = useMsal();
  const [loading, setLoading] = useState(true);

  const adminRole = JSON.parse(localStorage.getItem("adminRole"));
  let checkarea;
  if (adminRole[0].workArea === "สำนักงานใหญ่-นวนคร") {
    const itemsToDelete = [
      "อมตะซิตี้",
      "โรงงานอมตะซิตี้",
      "สำนักงานใหญ่-SKL",
      "อื่นๆ",
    ];
    checkarea = FILTER_ALL_DATA.checkBox.filter(
      (item) => !itemsToDelete.includes(item)
    );
  } else if (adminRole[0].workArea === "โรงงานอมตะซิตี้") {
    const itemsToDelete = ["สำนักงานใหญ่-นวนคร", "สำนักงานใหญ่-SKL", "อื่นๆ"];
    checkarea = FILTER_ALL_DATA.checkBox.filter(
      (item) => !itemsToDelete.includes(item)
    );
  } else if (adminRole[0].workArea === "สำนักงานใหญ่-SKL") {
    const itemsToDelete = [
      "สำนักงานใหญ่-นวนคร",
      "อมตะซิตี้",
      "โรงงานอมตะซิตี้",
      "อื่นๆ",
    ];
    checkarea = FILTER_ALL_DATA.checkBox.filter(
      (item) => !itemsToDelete.includes(item)
    );
  }
  const [filterSearch, setFilterSearch] = useState("");
  const [filterCheckbox, setFilterCheckbox] = useState(checkarea);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState(FILTER_ALL_DATA.endDate);

  useEffect(() => {
    if (parcelData.length < 1) {
      const token = getToken();
      const headers = {
        "Content-Type": "application/json",
        id_token: token.idToken,
        access_token: token.accessToken,
      };

      const fetchData = async () => {
        try {
          await fetch(
            `${process.env.REACT_APP_API_BASE_URL}/parcels/get-parcel-send-out`,
            {
              method: "GET",
              headers: headers,
            }
          )
            .then((response) => response.json())
            .then((jsonData) => {
              setParcelData(jsonData);
            });
        } catch (error) {
          instance.logoutRedirect();
          console.error("เกิดข้อผิดพลาดในการร้องขอข้อมูล", error);
        } finally {
          setLoading(false);
        }
      };
      fetchData();
    }
  }, [parcelData, instance]);

  const [PAGE_SIZE, setPageSize] = useState(10);

  const handleChangePageSize = (event) => {
    const newSize = parseInt(event.target.value);
    setPageSize(newSize);
  };

  const [currentPage, setCurrentPage] = useState(1);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const filteredData = search(
    parcelData,
    FILTER_ALL_DATA.columnParcel,
    filterSearch,
    filterCheckbox,
    startDate,
    endDate
  );

  const startIndex = (currentPage - 1) * PAGE_SIZE;
  const endIndex = Math.min(startIndex + PAGE_SIZE, filteredData.length);
  const paginatedData = filteredData.slice(startIndex, endIndex);

  return (
    <div>
      <p className={`${styles.pageHeading} text-orangeSKC`}>
        รายการพัสดุที่ส่งไปภายนอก
      </p>
      <div className={`${styles.adminPageBox} mt-12`}>
        <div className="flex">
          <SearchBar
            setFilterSearch={setFilterSearch}
            filterCheckbox={filterCheckbox}
            setFilterCheckbox={setFilterCheckbox}
            setStartDate={setStartDate}
            setEndDate={setEndDate}
            showStatusFilters={"SendParcelsOut"}
          />
        </div>
        <div className="px-0 ">
          {loading ? (
            <div
              role="status"
              className="flex items-center justify-center h-screen"
            >
              <svg
                aria-hidden="true"
                className="inline w-12 h-12 text-gray-200 animate-spin dark:text-borderLine fill-secondary"
                viewBox="0 0 100 101"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                  fill="currentColor"
                />
                <path
                  d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                  fill="currentFill"
                />
              </svg>
              <span className="sr-only">Loading...</span>
            </div>
          ) : (
            <div className="overflow-x-auto">
              <table className="w-full min-w-max table-auto text-left mt-4">
                <thead>
                  <tr>
                    {TABLE_HEAD.map((head, index) => (
                      <th
                        key={index}
                        className="border-y-2 border-blue-gray-100 bg-blue-gray-50/50 p-4 "
                      >
                        <div className="font-sarabun font-bold leading-none opacity-70">
                          {head}
                        </div>
                      </th>
                    ))}
                  </tr>
                </thead>

                <tbody>
                  {paginatedData.map((item, index) => (
                    <Table key={index + 1} item={item} index={index} />
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>

        <div className="flex items-center justify-between p-4 font-sarabun text-slate-500">
          <div>
            หน้าที่ {currentPage} จาก{" "}
            {Math.ceil(filteredData.length / PAGE_SIZE)}
          </div>
          <div>
            <select
              id="pageSizeSelect"
              value={PAGE_SIZE}
              onChange={handleChangePageSize}
              className={`${styles.permissionPageBtn} rounded-md hover:bg-hoverBackground duration-500`}
              style={{
                display: filteredData.length === 0 ? "none" : "inline-block",
              }}
            >
              <option value={5}>5</option>
              <option value={10}>10</option>
              <option value={15}>15</option>
            </select>
            &nbsp;&nbsp;
            <button
              className={`${styles.permissionPageBtn} rounded-md hover:bg-hoverBackground duration-500`}
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={
                currentPage === 1 ||
                Math.ceil(filteredData.length / PAGE_SIZE) === 0
              }
              style={{
                display: filteredData.length === 0 ? "none" : "inline-block",
              }}
            >
              ย้อนกลับ
            </button>
            &nbsp;&nbsp;
            <button
              className={`${styles.permissionPageBtn} rounded-md hover:bg-hoverBackground duration-500`}
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={
                currentPage === Math.ceil(filteredData.length / PAGE_SIZE) ||
                Math.ceil(filteredData.length / PAGE_SIZE) === 0
              }
              style={{
                display: filteredData.length === 0 ? "none" : "inline-block",
              }}
            >
              ถัดไป
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SendParcelsOut;
